import { render, staticRenderFns } from "./JP.vue?vue&type=template&id=2083af43&scoped=true&"
import script from "./JP.vue?vue&type=script&lang=js&"
export * from "./JP.vue?vue&type=script&lang=js&"
import style0 from "./JP.vue?vue&type=style&index=0&id=2083af43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2083af43",
  null
  
)

export default component.exports